import withRequiredAdmin from '../../HOC/withRequiredAdmin';
import AdminProject from './AdminProject';

export default withRequiredAdmin(AdminProject);
